import { render, staticRenderFns } from "./administrativaInformacionGeneral.vue?vue&type=template&id=ed527612"
import script from "./administrativaInformacionGeneral.vue?vue&type=script&lang=js"
export * from "./administrativaInformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports